import { CartesianChart } from '@/common/dashboard/charts/CartesianChart';
import { DashboardCard } from '@/common/dashboard/DashboardCard';
import { XAxisButton } from '@/common/dashboard/XAxisButton';
import { Mode } from '@/common/entityFramework/enumerations/Mode';
import { useForm } from '@/common/form/FormContext';
import { useNavState } from '@/common/navState/NavStateContext';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { useMemo } from 'react';

export const McdInvTrendCard = ({ xAxisOptions, metricOptions }) => {
  const { formValues } = useForm();
  const { navigateTo } = useNavState();
  const rsrc = useRsrc();

  const reqParam = useMemo(
    () => ({
      metric: formValues.metric,
      prodExpr: formValues.prodExpr,
      ctrtExpr: formValues.ctrtExpr,
      rbtPeriodExpr: formValues.rbtPeriodExpr,
      earnedPeriodExpr: formValues.earnedPeriodExpr,
      stateExpr: formValues.stateExpr,
      paidPeriodExpr: formValues.paidPeriodExpr,
      xAxis: formValues.xAxis,
    }),
    [
      formValues.metric,
      formValues.prodExpr,
      formValues.ctrtExpr,
      formValues.rbtPeriodExpr,
      formValues.earnedPeriodExpr,
      formValues.stateExpr,
      formValues.paidPeriodExpr,
      formValues.xAxis,
    ],
  );

  const navToMcdInvLineEntityList = (point) => {
    let entity = 'MCD_INV';
    rsrc
      .data('sc', 'MCD_INV_LINE_EXPR_DATA_PLUGIN', { ...reqParam, category: point.category, entity }, entity)
      .then((expr) => navigateTo('/sc/mcd-inv-line', { mode: Mode.LIST, expr }));
  };

  const metric =
    metricOptions
      .filter((option) => formValues.metric?.includes(option.value))
      .map((option) => option.displayName)
      .join(' & ') || metricOptions[0].displayName;
  const xAxisLabel = xAxisOptions.find((option) => option.code === formValues.xAxis)?.displayName;
  return (
    <DashboardCard
      title={metric + ' by ' + xAxisLabel}
      description={'Displays the Medicaid Invoice ' + metric + ' by ' + xAxisLabel}
      module="sc"
      plugin="MCD_INV_TREND_DATA_PLUGIN"
      reqParam={reqParam}
      buttons={<XAxisButton options={xAxisOptions} />}
    >
      {(data) => (
        <CartesianChart
          data={data}
          onClick={(point) => navToMcdInvLineEntityList(point)}
          legend="top"
          yLabel={'Amount in $'}
          allowNegative
          rotateXLabels
        />
      )}
    </DashboardCard>
  );
};
